module.exports = __webpack_public_path__ + "img/personnel.3dd5e2a7.png";